export const DD_LOG_KEY = '__ddLog';
const DD_TAB_KEY = '__ddTabId';
const DD_SESSION_KEY = '__ddSession';

export const tabId = sessionStorage.getItem(DD_TAB_KEY) || (() => {
  const id = Math.random().toString(36).slice(2, 7).toUpperCase();
  sessionStorage.setItem(DD_TAB_KEY, id);
  return id;
})();

let _nextId = 0;
export const ddLog = (() => {
  try {
    const arr = JSON.parse(localStorage.getItem(DD_LOG_KEY) || '[]');
    arr.forEach((e, i) => { if (e.id === undefined) e.id = i; });
    _nextId = arr.length > 0 ? Math.max(...arr.map(e => e.id)) + 1 : 0;
    return arr;
  } catch {
    localStorage.removeItem(DD_LOG_KEY);
    return [];
  }
})();

let _sessionId = null;
export function getSessionId() { return _sessionId; }

export function initLogSession(sessionId) {
  const stored = localStorage.getItem(DD_SESSION_KEY);
  if (stored && stored !== sessionId) {
    // Session changed — wipe stale logs from a previous session
    ddLog.length = 0;
    localStorage.removeItem(DD_LOG_KEY);
  }
  _sessionId = sessionId || null;
  if (sessionId) localStorage.setItem(DD_SESSION_KEY, sessionId);
}

export function pushLog(entry) {
  ddLog.push({ ...entry, tab: tabId, id: _nextId++ });
  try {
    const storable = ddLog.map(e => {
      if (e.response === undefined) return e;
      try { JSON.stringify(e.response); return e; } catch { const { response: _response, ...rest } = e; return rest; }
    });
    localStorage.setItem(DD_LOG_KEY, JSON.stringify(storable));
  } catch { /* quota or serialization error */ }
}

// Sync in-memory array when another tab writes to localStorage
window.addEventListener('storage', (ev) => {
  if (ev.key !== DD_LOG_KEY) return;
  try {
    const updated = JSON.parse(ev.newValue || '[]');
    ddLog.length = 0;
    ddLog.push(...updated);
    _nextId = updated.length > 0 ? Math.max(...updated.map(e => (e.id ?? 0))) + 1 : _nextId;
  } catch { /* ignore malformed cross-tab update */ }
});

window.__ddLog = ddLog;
window.__printDDLog = () => ddLog.map((e, i) => `${i + 1}. [${e.t}] ${e.label}`).join('\n');
